//
import creatorTorneoRutes from './torneoCreator.js'
import appsTorneoRutes from './torneoApps.js'


const torneoAdminRutes = [
  {
    path: '/ds/torneo-admin/:idTorneo',
    component: () => import('../views/torneoAdmin/IndexTorneoAdmin.vue'),
    meta: {requiresAuth: true, tipoRuta: 'T'},
    children: [
      {
        path: 'info',
        name: 'torneo-admin-info',
        component: () => import('../views/torneoAdmin/InfoTorneoAdminPage.vue'),
      },
      {
        path: 'delete',
        name: 'torneo-admin-delete',
        component: () => import('../views/torneoAdmin/DeleteTorneoAdminPage.vue'),
      },
      {
        path: 'equipos',
        name: 'torneo-admin-equipos',
        component: () => import('../views/torneoAdmin/EquiposTorneoAdminPage.vue'),
        children: [
          {
            path: 'inscritos',
            name: 'torneo-admin-equipos-ins',
            component: () => import('../views/torneoAdmin/EquiposInscritosTorneoAdminPage.vue'),
          },
          {
            path: 'solicitud',
            name: 'torneo-admin-equipos-solicitud',
            component: () => import('../views/torneoAdmin/EquiposSolicitudTorneoAdminPage.vue'),
          },
          {
            path: 'rechazados',
            name: 'torneo-admin-equipos-rechazados',
            component: () => import('../views/torneoAdmin/EquiposRechazadosTorneoAdminPage.vue'),
          },
        ]
      },
      {
        path: 'equipo/:idIns/plantel',
        name: 'torneo-admin-plantel',
        component: () => import('../views/torneoAdmin/TeamPlantelTorneoAdminPage.vue'),
      },
      {
        path: 'equipo-player/:idPlayer/cartilla',
        name: 'torneo-admin-player-carne',
        component: () => import('../views/torneoAdmin/CartillaPlayerTorneoPage.vue'),
      },
      {
        path: 'equipo/:idIns/download/plantel/',
        name: 'torneo-shop-admin-plantel-pdf',
        component: () => import('../viewshop/torneo/PlayersPdfTeamPage.vue'),
      },
      {
        path: 'equipo/:idIns/partidos',
        name: 'torneo-admin-team-partidos',
        component: () => import('../views/torneoAdmin/MatchesByTeamAdminPage.vue'),
      },
      {
        path: 'calendario',
        name: 'torneo-admin-calendario',
        component: () => import('../views/torneoAdmin/CalendarioTorneoAdminPage.vue'),
      },
      {
        path: 'calendar/creator',
        name: 'torneo-admin-creator-calendario',
        component: () => import('../views/torneoAdmin/CalendarioGeneratorAdminPage.vue'),
      },
      {
        path: 'resultados',
        name: 'torneo-admin-resultados',
        component: () => import('../views/torneoAdmin/ResultsTorneoAdminPage.vue'),
      },
      {
        path: 'plantilla/:idMatch/partido',
        name: 'torneo-admin-plantilla-match',
        component: () => import('../views/torneoAdmin/PlantillaMatchTorneoAdminPage.vue'),
      },
      {
        path: 'acta/:idMatch/:idLocal/:idVisita/partido',
        name: 'torneo-admin-acta-partido',
        component: () => import('../views/torneoAdmin/ActaPartidoPage.vue'),
      },
      {
        path: 'acta-especial/:idMatch/:idLocal/:idVisita/partido',
        name: 'torneo-admin-acta-especial-partido',
        component: () => import('../viewshop/torneoAdmin/ActaPartidoFutsalPage.vue'),
      },
      {
        path: 'tabla',
        name: 'torneo-admin-tabla',
        component: () => import('../views/torneoAdmin/TablaTorneoAdminPage.vue'),
      },
      {
        path: 'deportistas',
        name: 'torneo-admin-deportistas',
        component: () => import('../views/torneoAdmin/DeportistasTorneoAdminPage.vue'),
      },
      {
        path: 'deportistas/:idPlayer/historial-premium/',
        name: 'torneo-admin-deportistas-history',
        component: () => import('../views/torneoAdmin/HistoryTorneoPlayerPage.vue'),
      },
      {
        path: 'estadisticas',
        component: () => import('../views/torneoAdmin/EstadisticasTorneoAdminPage.vue'),
        children: [
          {
            path: 'goles',
            name: 'torneo-admin-estadisticas',
            component: () => import('../views/torneo/GoleadoresTorneouser.vue'),
          },
          {
            path: 'amarillas',
            name: 'torneo-admin-amarillas',
            component: () => import('../views/torneo/AmarillasTorneoUser.vue'),
          },
          {
            path: 'rojas',
            name: 'torneo-admin-rojas',
            component: () => import('../views/torneo/RojasTorneoUser.vue'),
          },
          {
            path: 'azules',
            name: 'torneo-admin-azules',
            component: () => import('../viewshop/torneoAdmin/AzulesTorneoAdminPage.vue'),
          },
        ]
      },
      {
        path: 'reportes',
        name: 'torneo-admin-reportes',
        component: () => import('../views/creator/CategoriasReporteTorneoPage.vue'),
      },
      {
        path: 'reportes/:nameCategory',
        name: 'torneo-admin-galeria',
        component: () => import('../views/creator/GaleriaReporteTorneoPage.vue'),
      },
      {
        path: 'finalizar',
        name: 'torneo-admin-finalizar',
        component: () => import('../views/torneoAdmin/FinishTorneoAdminPage.vue'),
      },
      {
        path: 'applications',
        name: 'torneo-apps',
        component: () => import('../views/torneoAdmin/AppsPage.vue'),
      },
    ].concat(creatorTorneoRutes, appsTorneoRutes)
  },
]

export default torneoAdminRutes